import React from "react";

export const PageContainer = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-6 py-8 ${className}`}>{children}</div>
);

export const PageHeader = ({ title, subtitle, actions, testId }) => (
  <div className="flex items-start justify-between mb-8" data-testid={testId}>
    <div>
      <h1 className="text-3xl font-bold text-gray-900 tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-gray-500">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center text-center py-16">
    <div className="w-16 h-16 rounded-full bg-[#EDE9FE] flex items-center justify-center mb-4">
      {Icon && <Icon className="text-[#7C3AED]" size={28} />}
    </div>
    <h3 className="text-lg font-bold text-gray-900 mb-1">{title}</h3>
    <p className="text-sm text-gray-500 mb-6 max-w-sm">{description}</p>
    {action}
  </div>
);
